import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import FormikSelect from "components/formik/FormikSelect";
import FormikTaxInput from "components/formik/FormikTaxInput";
import Button from "components/Button";

import countries from "libs/countries.json";
import billingDataSchema from "libs/validations/new_website_form/billingDataSchema";

const mainClass = "new-website-content__widget__billing";

const BillingModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();

  const { saveData, form_data, form_data_error } = useNewWebsite();

  const onSubmit = (values) => {
    saveData(values);

    if (typeof onClose === "function") onClose();
  };

  const select_options = countries?.map(({ name, name_pl, code }) => ({
    label: i18n?.language === "pl" ? name_pl || name : name,
    value: code,
  }));

  return (
    <ModalNew
      title={t("Change contact data")}
      variant="wide"
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <Formik
        initialValues={{
          billing: {
            name: form_data?.billing?.name || "",
            tax: {
              code: form_data?.billing?.tax?.code || "",
              number: form_data?.billing?.tax?.number || "",
            },
            street: form_data?.billing?.street || "",
            city: form_data?.billing?.city || "",
            post_code: form_data?.billing?.post_code || "",
            country: form_data?.billing?.country || "",
          },
        }}
        validationSchema={billingDataSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, setSubmitting);
        }}
      >
        {({ values, isSubmitting }) => (
          <Form className={mainClass} autoComplete="off">
            <div className={`${mainClass}__form`}>
              <FormikInput
                name="billing.name"
                label={t("Company name")}
                disabled={isSubmitting}
                placeholder={t("Acme Corporation")}
                required
              />
              <FormikTaxInput
                label={t("Tax identification number")}
                name="billing.tax"
                disabled={isSubmitting}
                invalid_tax={
                  form_data_error === "tax_id_invalid" ? true : false
                }
                required
              />
              <FormikInput
                name="billing.street"
                label={t("Street")}
                disabled={isSubmitting}
                placeholder={t("Main Street 13A")}
                required
              />
              <FormikInput
                name="billing.city"
                label={t("City")}
                placeholder={t("London")}
                disabled={isSubmitting}
                required
              />
              <FormikInput
                name="billing.post_code"
                label={t("Post code")}
                disabled={isSubmitting}
                placeholder="30-123"
                required
              />
              <FormikSelect
                name="billing.country"
                label={t("Country")}
                options={select_options}
                selected={values?.billing?.country}
                disabled={isSubmitting}
                searcher={true}
                placeholder={t("United Kingdom")}
                required
              />
            </div>
            <div className={`${mainClass}__cta`}>
              <Button type="submit">{t("Update data")}</Button>
            </div>
          </Form>
        )}
      </Formik>
    </ModalNew>
  );
};

export default BillingModal;
